
export interface ISampleProperties {
    name: string;
    customId: number;
    unit: string;
    totalCounts: string;
    mean: number;
    limit1: number;
    limit2: number;
    reject: number;
}

export interface ISampleOverviewData {
    id: string;
    name: string;
    measurementId:string;
    properties: ISampleProperties[];
}

export default class SampleOverviewData implements ISampleOverviewData {
    id: string;
    name: string;
    measurementId:string;
    properties: ISampleProperties[];

    constructor(
        id: string,
        name: string,
        measurementId:string,
        properties: ISampleProperties[],

    ) {
        this.id = id;
        this.name = name;
        this.measurementId = measurementId;
        this.properties = properties;
    }
}

const defaultSampleOverviewData = new SampleOverviewData("","", "", []);
export { defaultSampleOverviewData };
